import { render } from "./Table_Loader.vue?vue&type=template&id=1f762770&scoped=true"
import script from "./Table_Loader.vue?vue&type=script&lang=js"
export * from "./Table_Loader.vue?vue&type=script&lang=js"

import "./Table_Loader.vue?vue&type=style&index=0&id=1f762770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f762770"]])

export default __exports__